export default __webpack_public_path__ + "static/media/statuspage.579811d4.svg";